import React from "react";
import packageJson from "../../../package.json";
import { useTranslation } from "react-i18next";
import "./TermsCondition.css";

const TermsCondition = ({ setPopup }) => {
  const { t } = useTranslation();

  return (
    <div className="text-center">
      {/* <span
              className={"terms-conditions"}
              onClick={() => {
                setPopup(true);
              }}
            >
              {t("termsConditions")}
            </span> */}
      <br />
      <p className="app-version text-nowrap version-resp">
        <span> {packageJson.name} </span>
        {t("appVersion")}:- {packageJson.version}
        {t("labelYear")}
      </p>
    </div>
  );
};

export default TermsCondition;
